"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyStatisticsList = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../common");
const account_1 = require("../../base/account");
const academy_1 = require("../../../server/academy");
exports.AcademyStatisticsList = react_1.default.memo(({ searchOption, initPage, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const academyId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const role = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserRole)(state));
    const isAcademyAdmin = role === 'academy';
    const countRef = react_1.default.useRef(10);
    const [page, setPage] = react_1.default.useState(initPage);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [listData, setListData] = react_1.default.useState([]);
    const { data, refetch } = (0, academy_1.useAcademyMembers)(academyId, {
        ...(searchOption ? { member: searchOption } : {}),
        offset: page * countRef.current,
        limit: countRef.current,
        ...(isAcademyAdmin ? { privacy_consent: true } : {}),
    });
    const refetchList = (0, lodash_1.throttle)(() => refetch(), 1000, { leading: true, trailing: false });
    const headTitleList = [
        { title: 'idf', space: 1 },
        { title: 'name', space: 1 },
        { title: 'className', space: 2 },
    ];
    const tableReadDataKeys = [
        { title: 'member_idf', space: 1 },
        { title: 'member_name', space: 1 },
        { title: 'class_name', space: 2 },
    ];
    react_1.default.useEffect(() => {
        setPage(initPage);
    }, [initPage]);
    react_1.default.useEffect(() => {
        if (academyId)
            refetchList();
    }, [searchOption, page, academyId]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else if (items && items.length > 0) {
                setListData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setListData([]);
        setTotalCount(0);
    }, [data, page]);
    const handlerMoreData = (page) => {
        setPage(page);
        APP.eventManager.publish('UPDATE_PAGE', page);
    };
    const handlerSelectItem = (item) => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'detail',
            props: { id: item.member_id, class_id: item.class_id },
        });
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, t('academy.noStudentData')))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
                cursor: headItem.title === 'class_name' ? 'pointer' : 'default',
            }, onClick: headItem.title === 'class_name' ? () => handlerSelectItem(item) : undefined }, headItem.title === 'class_name' ? (react_1.default.createElement("p", { className: "overText2 underline" }, item[headItem.title])) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title])))));
    };
    return (react_1.default.createElement(common_1.Table, { className: "header-center", showIndex: true, indexOrder: "desc", isInnerPage: true, isInfinite: false, page: page, data: listData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData }));
});
